import Waterlist from './index.vue';

export default [
  {
    path: '/waterlist',
    name: 'Waterlist',
    component: Waterlist,
    meta: {
      title: '账户流水'
    }
  },
];



// WEBPACK FOOTER //
// ./src/views/Waterlist/index.js